export enum GfxRefInputTypeEnum  {
    Text = "text",
    Select = "select",
    Checkbox = "checkbox",
    Radio = "radio"
} 